import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import * as React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';
import Button from 'antd/lib/button';
import { displayTextForAutomationsToolboxSortType } from '../../helpers/displayHelpers';
import { AllAutomationsToolboxSortTypes, AutomationsToolboxSortType } from '../../types/sorts';
import { useDispatch, useSelector } from 'react-redux';
import { updateAutomationsToolboxSort } from '../../actions/sorts';
import { RootState } from '../../reducers/reducers';
import { selectAutomationsToolboxSort } from '../../selectors/selectors';
import { FolderOutlined, StarOutlined, ControlOutlined } from '@ant-design/icons';

const AutomationsToolboxSortComponent: React.FC = () => {
    const dispatch = useDispatch();

    const onSelectSort = (info) => {
        const sortType = info.key;
        dispatch(updateAutomationsToolboxSort({ sortType }));
    };

    const currentlySelectedSort = useSelector((state: RootState) => selectAutomationsToolboxSort(state));

    const overlayMenu = () => {
        return (
            <Menu onClick={onSelectSort} activeKey={currentlySelectedSort}>
                {AllAutomationsToolboxSortTypes.map((sortType) => (
                    <Menu.Item key={sortType} icon={iconForAutomationsToolboxSortType(sortType)}>
                        <div style={{ fontSize: 14, color: antGrey.grey9, fontWeight: 400 }}>
                            {displayTextForAutomationsToolboxSortType(sortType)}
                        </div>
                    </Menu.Item>
                ))}
            </Menu>
        );
    };

    return (
        <Dropdown overlay={overlayMenu} trigger={['click']}>
            <Button icon={iconForAutomationsToolboxSortType(currentlySelectedSort)}>
                Sort: {displayTextForAutomationsToolboxSortType(currentlySelectedSort)}
            </Button>
        </Dropdown>
    );
};

export default AutomationsToolboxSortComponent;

const iconForAutomationsToolboxSortType: (sortType: AutomationsToolboxSortType) => React.ReactNode = (sortType) => {
    const iconStyle: React.CSSProperties = { color: runwayColors.primary, paddingLeft: 4, paddingRight: 10 };
    switch (sortType) {
        case AutomationsToolboxSortType.Category:
            return <FolderOutlined style={iconStyle} />;
        case AutomationsToolboxSortType.New:
            return <StarOutlined style={iconStyle} />;
        case AutomationsToolboxSortType.Enabled:
            return <ControlOutlined style={iconStyle} />;
    }
};
